import React from 'react';
import EditTeaserState from './editTeaserState/EditTeaserState';
import ModalWindows from './components/ModalWindows/ModalWindows';
import ControlPanel from './components/ControlPanel/ControlPanel';
import Forms from './components/Forms/Forms';

const EditTeaserPage: React.FC = () => {
	return (
		<EditTeaserState>
			<ControlPanel />
			<Forms />
			<ModalWindows />
		</EditTeaserState>
	);
};

export default EditTeaserPage;
